export const selectForm = (state) => state.taxFilingInfo.form;
export const selectData = (state) => state.taxFilingInfo.data;
export const selectError = (state) => state.taxFilingInfo.error;
export const selectLoading = (state) => state.taxFilingInfo.loading;
